import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export const NewsletterForm = ({ dark }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/newsletter", { email });
      toast.success(data.message);
      setEmail("");
    } catch (err) { toast.error(errMsg(err)); } finally { setLoading(false); }
  };
  return (
    <form onSubmit={submit} className="flex" data-testid="newsletter-form">
      <input data-testid="newsletter-form-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Votre adresse e-mail" className={`flex-1 h-11 px-3 text-sm outline-none ${dark ? "bg-white/10 text-white placeholder:text-zinc-500 focus:bg-white/20" : "bg-white border border-zinc-300 text-[#0F172A]"}`} />
      <button data-testid="newsletter-form-submit" disabled={loading} className="h-11 px-4 bg-red-600 text-white text-xs font-bold uppercase tracking-wider hover:bg-red-700 disabled:opacity-60 transition-colors">{loading ? "…" : "S'abonner"}</button>
    </form>
  );
};
